import { Component, ElementRef, Inject, Injector, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from '../../../../services/AppComponentBase';




@Component({
    selector: "modal-ScannerAutoTrial",
    template: require('./ScannerAutoTrial.component.html'),
    styles: [require('./ScannerAutoTrial.component.css')]
})

export class ScannerAutoTrial extends AppComponentBase
 {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector);
    }

   private _dontShowAgain: boolean = false;
    public get dontShowAgain (): boolean {
        return this._dontShowAgain;
    }
    public set dontShowAgain ( value: boolean ) {
        this._dontShowAgain = value;

     
    }
}


